<div class="chart-section">
  <div class="section-header">
    <div class="section-icon reliability">
      <i class="bi bi-shield-check"></i>
    </div>
    <h2 class="section-title">Reliability</h2>
  </div>

  <div class="section-card">
    <app-progress [type]="typeProgress"></app-progress>

    <!-- Tabs -->
    <div class="section-tabs" *ngIf="+type() === 1">
      <button class="tab" [class.active]="typeFollowers === 1" (click)="setTypeFollowers(1)">
        <i class="bi bi-people"></i> Followers
      </button>
      <button class="tab" [class.active]="typeFollowers === 3" (click)="setTypeFollowers(3)">
        <i class="bi bi-building"></i> PRV & Business
      </button>
    </div>

    <!-- Loading -->
    <app-loader *ngIf="!(profileState | async).loader['audit']['followerStat']" size="sm" message="Analyzing followers..."></app-loader>

    <div [class.dimmed]="!(profileState | async).loader['audit']['followerStat']">
      <!-- Followers tab -->
      <div class="chart-grid" *ngIf="typeFollowers !== 3">
        <!-- Quality Followers -->
        <div class="chart-cell" [ngClass]="(!(profileState | async).boxExampleStatus[sectionName.qualityFollowers] && !((profileState | async).audit !== null && (profileState | async).audit.status)) ? 'sample-chart' : ''">
          <app-audit-example [name]="sectionName.qualityFollowers">
            <div class="chart-cell-header">
              <div>
                <h3>
                  <i class="bi bi-person-check cell-icon text-green"></i>
                  Quality followers
                  <span class="header-value" *ngIf="(profileState | async).boxExampleStatus[sectionName.qualityFollowers] || (profileState | async).audit.status == 2">
                    <span *ngIf="(profileState | async).followerStat !== null">{{(profileState | async).followerStat.followers.real_people.percent | number:'1.2'}}%</span>
                  </span>
                  <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.qualityFollowers] && (profileState | async).audit.status == 0">
                    <app-price-popup [type]="2"></app-price-popup>
                  </a>
                  <a class="info-tip" data-tooltip="Percent of valuable followers who have potential to interact with the posts (without mass followers or bots)">
                    <i class="bi bi-info-circle"></i>
                  </a>
                </h3>
                <p class="chart-sub" *ngIf="typeFollowers === 1">
                  <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.qualityFollowers] && (profileState | async).audit.status == 0">
                    <app-price-popup [type]="2"></app-price-popup>
                  </a>
                  <strong *ngIf="(profileState | async).boxExampleStatus[sectionName.qualityFollowers] || (profileState | async).followerStat !== null && (profileState | async).profileDetail !== null && (profileState | async).audit.status > 0">
                    {{Math().round(((profileState | async).followerStat.followers.real_people.percent / 100) * (profileState | async).profileDetail.followed_by) | separateNumbers}}
                  </strong>
                  <span class="text-muted">
                    of
                    <span *ngIf="(profileState | async).profileDetail !== null">{{(profileState | async).profileDetail.followed_by | separateNumbers}}</span>
                    total followers
                  </span>
                </p>
                <p class="chart-sub" *ngIf="typeFollowers === 2">
                  <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.qualityFollowers] && (profileState | async).audit.status == 0">
                    <app-price-popup [type]="2"></app-price-popup>
                  </a>
                  <span *ngIf="(profileState | async).boxExampleStatus[sectionName.qualityFollowers] || (profileState | async).audit.status > 0">
                    <span *ngIf="(profileState | async).followerStat !== null">>{{(profileState | async).followerStat.followers.real_people.value | separateNumbers}}</span>
                  </span>
                  <span class="text-muted">
                    of
                    <span *ngIf="(profileState | async).followerStat !== null">{{(profileState | async).followerStat.total_followers.value | separateNumbers}}</span>
                    total followers
                  </span>
                </p>
              </div>
            </div>

            <div class="chart-with-legend" *ngIf="chartsFollower !== undefined">
              <app-audit-placeholder [type]="auditType()" [name]="sectionName.qualityFollowers"></app-audit-placeholder>
              <div class="chart-pie-area">
                <div [chart]="chartsFollower[1]"></div>
              </div>
              <div class="chart-legend-area">
                <app-pie-legend [data]="chartsFollower[1]"></app-pie-legend>
              </div>
            </div>

            <div class="chart-insight" *ngIf="(profileState | async).followerStat !== null && (profileState | async).audit !== null && ((profileState | async).audit.status == 2 || (profileState | async).audit.status == 0)">
              <span class="level-badge" *ngIf="(profileState | async).boxExampleStatus[sectionName.qualityFollowers] || (profileState | async).audit.status == 2" [ngStyle]="{'background-color': getLevel((profileState | async).followerStat.followers.real_people.percent).bgcolor}">
                <span class="level-dot" [ngStyle]="{'background-color': getLevel((profileState | async).followerStat.followers.real_people.percent).color}"></span>
                {{getLevel((profileState | async).followerStat.followers.real_people.percent).text}}
              </span>
              <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.qualityFollowers] && (profileState | async).audit.status == 0">
                <app-price-popup [type]="2"></app-price-popup>
              </a>
              <span class="insight-label">Audience reachability</span>
              <p class="insight-detail">
                <strong *ngIf="(profileState | async).boxExampleStatus[sectionName.qualityFollowers] || (profileState | async).audit.status == 2">{{(profileState | async).followerStat.followers.real_people.percent | number:'1.2'}}%</strong>
                <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.qualityFollowers] && (profileState | async).audit.status == 0" class="trial-icon mr-1">
                  <app-price-popup [type]="2"></app-price-popup>
                </a>
                <span class="text-muted">of followers seems to be authentic</span>
              </p>
            </div>
          </app-audit-example>
        </div>

        <!-- Quality Distribution -->
        <div class="chart-cell" [ngClass]="(!(profileState | async).boxExampleStatus[sectionName.qualityDistribution] && !((profileState | async).audit !== null && (profileState | async).audit.status)) ? 'sample-chart' : ''">
          <app-audit-example [name]="sectionName.qualityDistribution">
            <div class="chart-cell-header">
              <div>
                <h3>
                  <i class="bi bi-bar-chart-steps cell-icon text-blue"></i>
                  Quality distribution
                  <a class="info-tip" data-tooltip="Followers distribution in terms of how many people they follow">
                    <i class="bi bi-info-circle"></i>
                  </a>
                </h3>
                <p class="chart-sub text-muted">by number of other profiles followed</p>
              </div>
            </div>

            <div class="chart-with-legend" *ngIf="chartsFollower !== undefined">
              <app-audit-placeholder [type]="auditType()" [name]="sectionName.qualityDistribution"></app-audit-placeholder>
              <div class="chart-pie-area">
                <div [chart]="chartsFollower[0]"></div>
              </div>
              <div class="chart-legend-area">
                <app-pie-legend [data]="chartsFollower[0]"></app-pie-legend>
              </div>
            </div>

            <div class="chart-insight" *ngIf="(profileState | async).followerStat !== null && (profileState | async).audit !== null && ((profileState | async).audit.status == 2 || (profileState | async).audit.status == 0)">
              <span class="level-badge" [ngStyle]="{'background-color': getLevel((profileState | async).followerStat.quality_distribution_summary.percent).bgcolor}" *ngIf="(profileState | async).boxExampleStatus[sectionName.qualityDistribution] || (profileState | async).audit.status == 2">
                <span class="level-dot" [ngStyle]="{'background-color': getLevel((profileState | async).followerStat.quality_distribution_summary.percent).color}"></span>
                {{getLevel((profileState | async).followerStat.quality_distribution_summary.percent).text}}
              </span>
              <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.qualityDistribution] && (profileState | async).audit.status == 0">
                <app-price-popup [type]="2"></app-price-popup>
              </a>
              <span class="insight-label">Audience authenticity</span>
              <p class="insight-detail">
                <strong *ngIf="(profileState | async).boxExampleStatus[sectionName.qualityDistribution] || (profileState | async).audit.status == 2">{{(profileState | async).followerStat.quality_distribution_summary.percent | number:'1.2'}}%</strong>
                <a *ngIf="!(profileState | async).boxExampleStatus[sectionName.qualityDistribution] && (profileState | async).audit.status == 0" class="mr-1">
                  <app-price-popup [type]="2"></app-price-popup>
                </a>
                <span class="text-muted">of audience follows less than 1,500 profiles</span>
              </p>
            </div>
          </app-audit-example>
        </div>
      </div>

      <!-- PRV & Business tab -->
      <div class="chart-grid" *ngIf="typeFollowers === 3">
        <div class="chart-cell">
          <div class="chart-cell-header">
            <h3><i class="bi bi-lock cell-icon text-purple"></i> Private accounts</h3>
          </div>
          <div class="chart-with-legend" *ngIf="chartsFollower !== undefined">
            <div class="chart-pie-area">
              <div [chart]="chartsFollower[2]"></div>
            </div>
            <div class="chart-legend-area">
              <app-pie-legend [data]="chartsFollower[2]"></app-pie-legend>
            </div>
          </div>
        </div>
        <div class="chart-cell">
          <div class="chart-cell-header">
            <h3><i class="bi bi-briefcase cell-icon text-blue"></i> Business accounts</h3>
          </div>
          <div class="chart-with-legend" *ngIf="chartsFollower !== undefined">
            <div class="chart-pie-area">
              <div [chart]="chartsFollower[3]"></div>
            </div>
            <div class="chart-legend-area">
              <app-pie-legend [data]="chartsFollower[3]"></app-pie-legend>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>